import { get } from 'lodash';
import { resolve, reject } from 'redux-optimist-promise';

export const FETCH_BOOKING_CART = 'FETCH_BOOKING_CART';
const UPDATE_BOOKING_CART = 'UPDATE_BOOKING_CART';

export const initialState = {
  data: {},
  errorResponse: {},
  editingServiceId: '',
  stay: {},
};

export const bookingCartReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_BOOKING_CART:
      return {
        ...state,
        stay: action.payload.stay,
      };
    case resolve(FETCH_BOOKING_CART):
      return {
        ...state,
        data: get(action, 'payload', {}),
        errorResponse: {},
      };
    case reject(FETCH_BOOKING_CART):
      return {
        ...state,
        errorResponse: {
          errors: action.payload.errors,
        },
      };
    case UPDATE_BOOKING_CART:
      return {
        ...state,
        editingServiceId: action.payload.id,
      };
    case resolve(UPDATE_BOOKING_CART):
      return {
        ...state,
        editingServiceId: '',
        data: {
          ...state.data,
          userBooking: {
            ...state.data.userBooking,
            ...action.payload.addServiceCart,
            ...action.payload.removeServiceCart,
          },
        },
      };
    case reject(UPDATE_BOOKING_CART):
      return {
        ...state,
        editingServiceId: '',
        errorResponse: {
          errors: action.payload.errors,
        },
      };
    default:
      return state;
  }
};
